// extracted by mini-css-extract-plugin
export default {"spinners_container":"Loader_spinners_container__zq9xS","spinner":"Loader_spinner__DydzZ","loading":"Loader_loading__QV+Jy"};